// Atmospheric fog + blood-red glow background. Pointer-events none, sits behind content.
export const Fog = () => {
  return (
    <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-background">
      <div className="absolute -top-40 -left-40 h-[40rem] w-[40rem] rounded-full bg-primary/10 blur-[120px] fog-layer" />
      <div className="absolute top-1/3 -right-40 h-[36rem] w-[36rem] rounded-full bg-primary/[0.07] blur-[140px] fog-layer-slow" />
      <div className="absolute -bottom-40 left-1/4 h-[34rem] w-[34rem] rounded-full bg-white/[0.03] blur-[130px] fog-layer" />
      <div className="absolute inset-0 grain opacity-[0.06] mix-blend-overlay" />
    </div>
  );
};

export default Fog;
